exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0-alpha.6/css/bootstrap.min.css);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto);", ""]);

// module
exports.push([module.id, "body,html{height:100vh;background-color:#f9f9f9}.row{margin-top:1rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js!./~/vue-loader/lib/selector.js?type=style&index=0!./docs/App.vue
// module id = 44
// module chunks = 0